import { ChangeDetectionStrategy, Component, ViewChild, inject } from '@angular/core';
import { GridOptions } from 'ag-grid-community';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DocumentCodeService } from 'src/app/services/labels/document-code.service';
import { ArrayUtils } from 'src/app/shared/utils/array.utils';
import { AgnosticGridsComponent } from '../../agnostic-grid/agnostic-grids/agnostic-grids.component';
import { GridTypeConstants } from '../../agnostic-grid/agnostic-grids/constants/gridTypeConstants';
import { GridData } from '../../agnostic-grid/models/gridData-model';
import { Button } from 'primeng/button';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faSave, faTimes } from '@fortawesome/pro-solid-svg-icons';

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  selector: 'app-template-selection-dialog',
  templateUrl: './templateSelectionDialog.component.html',
  imports: [AgnosticGridsComponent, Button, TranslateModule, FaIconComponent],
})
export class TemplateSelectionDialogComponent {
  readonly ref = inject(DynamicDialogRef);
  readonly dynamicDialogConfig = inject(DynamicDialogConfig);
  private readonly documentService = inject(DocumentCodeService);
  private readonly translateService = inject(TranslateService);

  public readonly faTimes = faTimes;
  public readonly faSave = faSave;

  public gridDependencies!: GridData;

  public gridInstance!: AgnosticGridsComponent;
  @ViewChild(AgnosticGridsComponent) public set gridInstanceChild(gridInstance: AgnosticGridsComponent) {
    if (gridInstance) {
      this.gridInstance = gridInstance;
    }
  }

  constructor() {
    this.fetchDocuments();
  }

  private fetchDocuments() {
    this.documentService.searchCollection('getAll').subscribe((values) => {
      const filteredValues = values.resources.filter(
        (value) =>
          value.categorie?.toLowerCase().includes(this.dynamicDialogConfig.data.type.toLowerCase()) && value.inhoud,
      );
      this.createGridDependencies(filteredValues);
    });
  }

  private createGridDependencies(filteredValues: any[]) {
    const gridOptions: GridOptions = GridTypeConstants.getNormalGridOptions();
    gridOptions.rowSelection = {
      mode: 'multiRow',
    };
    this.gridDependencies = {
      rawJsonData: filteredValues,
      structure: [
        {
          field: 'naam',
          headerName: this.translateService.instant('fields.name'),
          editable: false,
          flex: 1,
        },
      ],
      gridOptions,
      componentName: 'templateSelectionDialog',
    };
  }

  public hideDialog() {
    this.ref.close([]);
  }

  public addTemplateContent() {
    this.ref.close(ArrayUtils.ensureArray(this.gridInstance?.gridApi?.getSelectedRows()));
  }

  public isSaveDisabled() {
    return this.gridInstance?.gridApi?.getSelectedRows()?.length == 0;
  }
}
